import React from "react";
import { Box, Skeleton, Toolbar } from "@mui/material";

export interface ToolbarSkeletonProps {
  hideCheckbox?: boolean; // Select all checkbox
  hideActions?: boolean; // Print button
}

export const ToolbarSkeleton: React.FC<ToolbarSkeletonProps> = ({
  hideCheckbox = true,
  hideActions = true,
}) => {
  return (
    <Toolbar
      sx={{
        flexWrap: "wrap",
        gap: 1,
        pl: { sm: 1 },
        pr: { xs: 1, sm: 1 },
      }}
    >
      {/* Checkbox */}
      {!hideCheckbox && (
        <Box sx={{ pr: "12px", display: "flex" }}>
          <Skeleton variant="rectangular" width={24} height={24} />
        </Box>
      )}

      {/* Title */}
      <Box sx={{ flex: "1 1", minWidth: 150 }}>
        <Skeleton
          variant="rounded"
          width="100%"
          height={32}
          sx={{ maxWidth: 220, ml: 1 }}
        />
      </Box>

      {/* Print Button */}
      {!hideActions && <Skeleton variant="rounded" width={115} height={32} />}

      {/* Sort Dropdown */}
      <Skeleton variant="rounded" width={100} height={32} />
    </Toolbar>
  );
};
